import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "movie-list-container" }
const _hoisted_2 = {
  key: 0,
  class: "no-movies"
}
const _hoisted_3 = {
  key: 1,
  class: "movie-grid"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "movie-title" }
const _hoisted_6 = {
  key: 0,
  class: "movie-description"
}
const _hoisted_7 = { class: "movie-meta" }
const _hoisted_8 = {
  key: 0,
  class: "created-date"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.movies.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, [
            _createTextVNode("No movies found. "),
            _createElementVNode("a", { href: "#new-movie" }, "Create your first movie"),
            _createTextVNode(" to get started!")
          ], -1 /* CACHED */)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, [
            _createTextVNode(" Get started by "),
            _createElementVNode("a", { href: "#new-movie" }, "creating a movie."),
            _createTextVNode(" or selecting one below ")
          ], -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.movies, (movie) => {
            return (_openBlock(), _createElementBlock("div", {
              key: movie.id,
              class: "movie-card",
              onClick: $event => ($setup.handleSelectMovie(movie.id))
            }, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(movie.name || 'Untitled Movie'), 1 /* TEXT */),
              (movie.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(movie.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_7, [
                (movie.createdAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Created: " + _toDisplayString(new Date(movie.createdAt).toLocaleDateString()), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ]))
}